export const APP_NAME = 'Robosize';

export const alternate_name = name => `${name ? name : APP_NAME}`;
